import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

// Reactstrap
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

// import images
import logo from "../../assets/images/logo.png"
import logoLightSvg from "../../assets/images/logo.png"

// i18n
import { withTranslation } from "react-i18next"

// Redux Store
import { showRightSidebarAction, changeLayoutMode } from "../../store/actions"

const Header = props => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const obj = JSON.parse(localStorage.getItem("authUser"))
  const userId = obj.username

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const handleLogout = () => {
    // Implement logout logic here
    console.log("User logged out")
    // Example: Remove user from localStorage and redirect
    window.location.href = "/login"
  }

  const [search, setSearch] = useState(false)
  const [selectedOption, setSelectedOption] = useState("") // Initialize with "Admin" or default name

  // Handle option selection
  const handleOptionSelect = option => {
    setSelectedOption(option) // Update the selected option
  }

  const toggleFullscreen = () => {
    const docElement = document.documentElement
    if (!document.fullscreenElement) {
      docElement.requestFullscreen?.() ||
        docElement.mozRequestFullScreen?.() ||
        docElement.webkitRequestFullscreen?.()
    } else {
      document.cancelFullScreen?.() ||
        document.mozCancelFullScreen?.() ||
        document.webkitCancelFullScreen?.()
    }
  }

  // Ensure the layout mode is retrieved from localStorage during initial load
  useEffect(() => {
    const savedLayoutMode = localStorage.getItem("layoutMode")

    // Check if saved layout mode exists and is different from the current mode
    if (savedLayoutMode && savedLayoutMode !== props.layoutModeType) {
      props.changeLayoutMode(savedLayoutMode) // Only update the state if it's different
    } else if (!savedLayoutMode) {
      // If no layout mode is saved, set it to 'dark' by default
      props.changeLayoutMode("dark")
    }
  }, [props.layoutModeType, props.changeLayoutMode]) // Only run on mount, not on every render

  const toggleLayoutMode = () => {
    const newMode = props.layoutModeType === "dark" ? "light" : "dark"
    props.changeLayoutMode(newMode)

    // Save the new layout mode to localStorage whenever it changes
    localStorage.setItem("layoutMode", newMode)
  }

  const toggleSidebar = () => {
    document.body.classList.toggle("sidebar-enable", window.screen.width <= 998)
    document.body.classList.toggle("vertical-collpsed")
  }

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
        <div className="navbar-brand-box d-lg-none d-md-block d-flex justify-content-center align-items-center">
  <Link to="/" className="logo logo-dark">
    <span className="logo-sm">
      <img src={logo} alt="Logo" height="40" />
    </span>
  </Link>
  <Link to="/" className="logo logo-light">
    <span className="logo-sm">
      <img src={logo} alt="Logo" height="40" />
    </span>
  </Link>
</div>


          <button
            type="button"
            onClick={toggleSidebar}
            className="btn btn-sm px-3 font-size-16 header-item"
            id="vertical-menu-btn"
          >
            <i className="fa fa-fw fa-bars" />
          </button>

          <form className="app-search d-none d-lg-block">
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder={props.t("Search") + " ..."}
              />
              <span className="bx bx-search-alt" />
            </div>
          </form>
        </div>

        <div className="d-flex">
          <div className="dropdown d-inline-block d-lg-none ms-2">
            <button
              onClick={() => setSearch(!search)}
              type="button"
              className="btn header-item noti-icon"
              id="page-header-search-dropdown"
            >
              <i className="mdi mdi-magnify" />
            </button>
            {search && (
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show">
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
          <ProfileMenu onSelectOption={handleOptionSelect} />

          <div className="dropdown d-none d-lg-inline-block ms-1">
            <button
              type="button"
              onClick={toggleFullscreen}
              className="btn header-item noti-icon"
              data-toggle="fullscreen"
            >
              <i className="bx bx-fullscreen" />
            </button>
          </div>

          {/* <div className="dropdown d-inline-block">
            <button
              type="button"
              onClick={toggleLayoutMode}
              className="btn header-item noti-icon"
            >
              <i className={props.layoutModeType === 'dark' ? "bx bx-sun" : "bx bx-moon"} />
            </button>
          </div> */}

          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggleDropdown}
            className="d-inline-block"
          >
            <DropdownToggle
              tag="button"
              type="button"
              className="btn header-item noti-icon"
            >
              <i className="bx bx-user" /> {/* Account icon */}
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem style={{ display: "flex", alignItems: "center" }}>
                <div
                  className="dropdown-item"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <i
                    className="bx bx-user-circle font-size-16"
                    style={{ marginRight: "8px" }}
                  ></i>
                  {userId}
                </div>
              </DropdownItem>
              <div className="dropdown-divider" />

              <DropdownItem style={{ display: "flex", alignItems: "center" }}>
                <Link to="/logout" className="dropdown-item">
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
                  <span>{props.t("Logout")}</span>
                </Link>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  changeLayoutMode: PropTypes.func,
  layoutModeType: PropTypes.string,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { layoutModeType, showRightSidebar } = state.Layout
  return { layoutModeType, showRightSidebar }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  changeLayoutMode,
})(withTranslation()(Header))
